<template>
    <div>
        <v-expansion-panels v-model="panelModel" dense focusable>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('module.balance') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <str-worker-autocomplete
                                    v-model="filter.workerId"
                                    :label="$t('module.worker')"
                                />
                            </v-col>
                            <v-col cols="12" v-if="!vacation">
                                <str-balance-autocomplete
                                    v-model="filter.balanceId"
                                    :label="$t('module.balance')"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense v-if="vacation">
                            <v-col cols="12">
                                <w-month-picker
                                    v-model="filter.startMonth"
                                    :label="$t('common.start_month')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-month-picker
                                    v-model="filter.endMonth"
                                    :label="$t('common.end_month')"
                                />
                            </v-col>
                        </v-row>
                        <v-row dense v-else>
                            <v-col cols="12">
                                <w-date-picker
                                    v-model="filter.start"
                                    :label="$t('common.start')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                    v-model="filter.end"
                                    :label="$t('common.end')"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('module.worker') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.phase"
                                    :items="workerPhases"
                                    :label="$t('worker.status')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <organizational-chart-select
                                    v-model="filter.organizationalchartIds"
                                    :label="$t('module.organizational_charts')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-occupation-autocomplete
                                    v-model="filter.occupationId"
                                    :label="$t('module.occupation')"
                                />
                            </v-col>
                            
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.workplaceId"
                                    type="WORKER_WORKPLACE"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.companyId"
                                    type="WORKER_COMPANY"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.stateId"
                                    type="WORKER_STATE"
                                    show-default-label
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.sex"
                                    :items="sex"
                                    :label="$t('common.sex')"
                                ></w-enum-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('common.formula') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.field"
                                    label="Champ"
                                    :items="[
                                        {id: 'totalRemaining', name: $t('balance.totalRemaining')},
                                        {id: 'value', name: $t('balance.value')},
                                        {id: 'total', name: $t('balance.total')},
                                        {id: 'taken', name: $t('balance.taken')},
                                        {id: 'remain', name: $t('balance.remain')},
                                    ]"
                                    not-clearable
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-autocomplete
                                    v-model="filter.operation"
                                    :items="simpleOperations"
                                    :label="$t('common.operation')"
                                ></w-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <w-text-field
                                    v-model="filter.value"
                                    :label="$t('common.value')"
                                    type="number"
                                ></w-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        
        <input type="hidden"/>
    </div>
</template>

<script>
import useSharedSelectData from "@/use/SharedSelectData.js";
import {ref, watch} from "vue";
import StrBalanceAutocomplete from "@/views/Absence/Balance/Components/StrBalanceAutocomplete.vue";

export default {
    components: {StrBalanceAutocomplete},
    props: {
        value: Object,
        vacation: Boolean,
    },
    setup(props, {emit}) {
        const {simpleOperations, workerPhases, sex} = useSharedSelectData();
        const filter = ref({});
        const panelModel = ref(0);
        
        const period = ref(null);
        watch(() => period.value, () => {
            if (period.value) {
                filter.value = {...filter.value, minYear: period.value.previous, maxYear: period.value.next}
            } else {
                filter.value = {...filter.value, minYear: null, maxYear: null}
            }
        });
        
        watch(() => props.value, () => {
            filter.value = props.value;
        }, {immediate: true});
        
        watch(() => filter.value, () => {
            emit('input', filter.value);
        }, {deep: true});
        
        return {
            simpleOperations,
            workerPhases,
            sex,
            filter,
            period,
            panelModel
        }
    },
};
</script>